import React, { useEffect, useState } from 'react';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { v4 as uuid } from 'uuid';
import iPosto from '../interfaces/iPosto';

interface iRegistros {
    ano?: string;
    mes?: string;
    posto_alt?: string;
    posto_lat?: string;
    posto_lon?: string;
    posto_nome?: string;
    dia_01?: string;
    dia_02?: string;
    dia_03?: string;
    dia_04?: string;
    dia_05?: string;
    dia_06?: string;
    dia_07?: string;
    dia_08?: string;
    dia_09?: string;
    dia_10?: string;
    dia_11?: string;
    dia_12?: string;
    dia_13?: string;
    dia_14?: string;
    dia_15?: string;
    dia_16?: string;
    dia_17?: string;
    dia_18?: string;
    dia_19?: string;
    dia_20?: string;
    dia_21?: string;
    dia_22?: string;
    dia_23?: string;
    dia_24?: string;
    dia_25?: string;
    dia_26?: string;
    dia_27?: string;
    dia_28?: string;
    dia_29?: string;
    dia_30?: string;
    dia_31?: string;
    [key: string]: string | undefined;
}

const ConsultarRegistro = ({ setCurrentPage }: { setCurrentPage: Function; }) => {

    const apiUrl = process.env.REACT_APP_API_URL;

    const [registros, setRegistros] = useState<iRegistros[]>([]);

    const [filteredList, setFilteredList] = useState<iRegistros[]>([]);

    const [postosList, setPostosList] = useState<iPosto[]>([]);

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const inputFilterInitialState = {
        filter_mes_01: true,
        filter_mes_02: true,
        filter_mes_03: true,
        filter_mes_04: true,
        filter_mes_05: true,
        filter_mes_06: true,
        filter_mes_07: true,
        filter_mes_08: true,
        filter_mes_09: true,
        filter_mes_10: true,
        filter_mes_11: true,
        filter_mes_12: true,
        posto: 'Todos',
        filter_totalZero: true,
        filter_registrosVazios: true,
        filter_registrosIncompletos: true,
        filter_data_de: '',
        filter_data_ate: '',
        filter_soma_minima: '',
        filter_soma_maxima: ''
    };
    const [inputFilter, setInputFilter] = useState(inputFilterInitialState);

    const { filter_mes_01, filter_mes_02, filter_mes_03, filter_mes_04, filter_mes_05, filter_mes_06, filter_mes_07, filter_mes_08, filter_mes_09, filter_mes_10, filter_mes_11, filter_mes_12, posto, filter_totalZero, filter_registrosVazios, filter_registrosIncompletos, filter_data_de, filter_data_ate, filter_soma_minima, filter_soma_maxima } = inputFilter;

    const handleClear = () => {
        setInputFilter(inputFilterInitialState);
    };

    const numeroToMes = (mes?: string) => {
        switch (mes) {
            case '1':
                return 'Janeiro';
            case '2':
                return 'Fevereiro';
            case '3':
                return 'Março';
            case '4':
                return 'Abril';
            case '5':
                return 'Maio';
            case '6':
                return 'Junho';
            case '7':
                return 'Julho';
            case '8':
                return 'Agosto';
            case '9':
                return 'Setembro';
            case '10':
                return 'Outubro';
            case '11':
                return 'Novembro';
            case '12':
                return 'Setembro';

        }
    };

    const contarDiasZero = (obj: iRegistros): number => {
        let contador = 0;
        for (const chave in obj) {
            if (chave.startsWith('dia_') && obj[chave] === '0') {
                contador++;
            }
        }
        return contador;
    };

    const somarDias = (registro: iRegistros): string => {
        let soma = 0;
        for (const chave in registro) {
            if (chave.startsWith('dia_')) {
                const valor = parseFloat(registro[chave] || '0');
                soma += valor;
            }
        }
        return soma.toFixed(1);
    };

    const diasComChuva = (registro: iRegistros): number => {
        let contador = 0;
        for (const chave in registro) {
            if (chave.startsWith('dia_')) {
                const valor = registro[chave];
                if (valor !== '0' && valor !== null && valor !== undefined && valor !== '') {
                    contador++;
                }
            }
        }
        return contador;
    };

    const diasSemRegistro = (registro: iRegistros): number => {
        let contador = 0;
        for (const chave in registro) {
            if (chave.startsWith('dia_')) {
                const valor = registro[chave];
                if (valor === null || valor === undefined || valor === '') {
                    contador++;
                }
            }
            if (chave === `dia_${numeroDeDiasDoMes(registro.mes, registro.ano)}`) {
                break;
            }
        }
        return contador;
    };

    const handleSearchInputChanges = (element: any, checkbox = false) => {
        if (checkbox) {
            setInputFilter({ ...inputFilter, [element.target.name]: element.target.checked });
        } else {
            setInputFilter({ ...inputFilter, [element.target.name]: element.target.value });
        }
    };

    const getRegistros = async () => {
        const response = await fetch(`${apiUrl}/consulta-registros`);
        const jsonResponse = await response.json();
        setFilteredList(jsonResponse);
        setRegistros(jsonResponse);
    };

    const getPostos = async () => {
        const response = await fetch(`${apiUrl}/all-postos`);
        const jsonResponse = await response.json();
        setPostosList(jsonResponse);
    };

    // FILTROS
    const filtraDatas = (lista_de_objetos: iRegistros[], data_de: string | null | undefined, data_ate: string | null | undefined): iRegistros[] => {
        // Definindo a data mínima padrão e a data atual
        if (data_de === '' || data_ate === '') {
            return lista_de_objetos;
        }
        const dataInicial = data_de ? new Date(data_de) : new Date("0001-01-01");
        const dataFinal = data_ate ? new Date(data_ate) : new Date();
        // Função para converter ano, mes e dia em uma data
        const converteParaData = (ano: string, mes: string, dia: string): Date | null => {
            if (ano && mes && dia) {
                const dataStr = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
                return new Date(dataStr);
            }
            return null;
        };
        const listaFiltrada = lista_de_objetos.filter(obj => {
            for (let dia = 1; dia <= 31; dia++) {
                const diaStr = `dia_${dia.toString().padStart(2, '0')}`;
                if (obj[diaStr]) {
                    const dataRegistro = converteParaData(obj.ano!, obj.mes!, dia.toString());
                    if (dataRegistro && dataRegistro >= dataInicial && dataRegistro <= dataFinal) {
                        return true;
                    }
                }
            }
            return false;
        });
        return listaFiltrada;
    };

    const filtraMeses = (filtros: any, lista_de_objetos: iRegistros[]): iRegistros[] => {
        return lista_de_objetos.filter(obj => {
            const mes = parseInt(obj.mes || "0");
            const filtroMes = filtros[`filter_mes_${mes.toString().padStart(2, '0')}` as keyof typeof filtros];
            return filtroMes;
        });
    };

    const filtraPorPosto = (posto: string, lista_de_objetos: iRegistros[]): iRegistros[] => {
        if (posto === "Todos" || posto === "" || posto === undefined || posto === null) {
            return lista_de_objetos;
        }

        return lista_de_objetos.filter(obj => obj.posto_nome === posto);
    };

    const filtrarRegistrosVazios = (lista: iRegistros[], registrosVazios: boolean): iRegistros[] => {
        if (registrosVazios) {
            return lista;
        }

        return lista.filter(registro => {
            // Verifica se pelo menos um campo "dia_" contém um número
            return Object.keys(registro).some(key => {
                if (key.startsWith('dia_')) {
                    const valor = registro[key];
                    return valor !== null && valor !== undefined && valor !== '' && !isNaN(Number(valor));
                }
                return false;
            });
        });
    };

    const filtrarRegistrosIncompletos = (lista: iRegistros[], incompleto: boolean): iRegistros[] => {
        if (incompleto) {
            return lista;
        }

        const mesesComDias: any = {
            '01': 31, '02': 28, '03': 31, '04': 30, '05': 31, '06': 30,
            '07': 31, '08': 31, '09': 30, '10': 31, '11': 30, '12': 31,
        };

        function isAnoBissexto(ano: number): boolean {
            return (ano % 4 === 0 && ano % 100 !== 0) || (ano % 400 === 0);
        }

        return registros.filter(registro => {
            const mes = registro.mes?.padStart(2, '0');
            const ano = parseInt(registro.ano || '');
            let maxDias = mes ? mesesComDias[mes] : 0;

            if (mes === '02' && isAnoBissexto(ano)) {
                maxDias = 29; // Considera 29 dias em fevereiro para anos bissextos
            }

            for (let dia = 1; dia <= 31; dia++) {
                const key = `dia_${dia.toString().padStart(2, '0')}`;
                const valor = registro[key];

                if (dia <= maxDias) {
                    if (valor === null || valor === undefined || valor === '') {
                        return false;
                    }
                }
            }

            return true;
        });
    };

    const filtrarDiasSemChuva = (lista: iRegistros[], semChuva: boolean): iRegistros[] => {
        if (semChuva) {
            return lista;
        }
        return lista.filter((registro: iRegistros) => {
            return Number(somarDias(registro)) > 0;
        });
    };

    const filtrarSoma = (lista: iRegistros[]): iRegistros[] => {
        if (Number(inputFilter.filter_soma_minima) === 0 && Number(inputFilter.filter_soma_maxima) === 0) {
            return lista;
        }
        if (inputFilter.filter_soma_minima !== '' && inputFilter.filter_soma_minima !== undefined && inputFilter.filter_soma_minima !== null) {
            lista = lista.filter((registro: iRegistros) => {
                return Number(somarDias(registro)) >= Number(inputFilter.filter_soma_minima);
            });
        }
        if (inputFilter.filter_soma_maxima !== '' && inputFilter.filter_soma_maxima !== undefined && inputFilter.filter_soma_maxima !== null) {
            lista = lista.filter((registro: iRegistros) => {
                return Number(somarDias(registro)) <= Number(inputFilter.filter_soma_maxima);
            });
        }

        return lista;
    };

    const chuvaFormatada = (chuva: string | undefined) => {
        if (chuva === null || chuva === undefined || chuva === "") {
            return chuva;
        }
        return Number(chuva).toFixed(1);
    };

    const handleBuscar = async () => {
        let filtered = registros;
        filtered = filtraDatas(filtered, filter_data_de, filter_data_ate);
        filtered = filtraMeses(inputFilter, filtered);
        filtered = filtraPorPosto(inputFilter.posto, filtered);
        filtered = filtrarRegistrosVazios(filtered, inputFilter.filter_registrosVazios);
        filtered = filtrarRegistrosIncompletos(filtered, inputFilter.filter_registrosIncompletos);
        filtered = filtrarDiasSemChuva(filtered, inputFilter.filter_totalZero);
        filtered = filtrarSoma(filtered);
        setFilteredList(filtered);
    };

    const numeroDeDiasDoMes = (mes: number | string | undefined, ano: number | string | undefined) => {
        return new Date(Number(ano), Number(mes), 0).getDate();
    };

    const handlePdf = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

        saveAs(blob, "data.xlsx");
    };

    const handleInit = async () => {
        await getRegistros();
        await getPostos();
        setIsLoading(false);
    };

    useEffect(() => {
        setCurrentPage(window.location.pathname);
        handleInit();
    }, []);

    return (
        <>
            <div className="card m-5 css-app-cinza-claro">
                <h5 className="card-header">Filtros</h5>
                <div className="card-body d-flex flex-wrap computador-view">

                    <div className="card m-1">
                        <h6 className="card-header">Data</h6>
                        <div className="card-body d-flex flex-column">
                            <div className="input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">De</span>
                                <input type="date" className="form-control" name="filter_data_de" value={filter_data_de} onChange={e => handleSearchInputChanges(e)} />
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">até</span>
                                <input type="date" className="form-control" name="filter_data_ate" value={filter_data_ate} onChange={e => handleSearchInputChanges(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="card m-1">
                        <h6 className="card-header">Meses</h6>
                        <div className="card-body d-flex">
                            <div className="d-flex flex-column">
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_01" name="filter_mes_01" checked={filter_mes_01} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_01">
                                        Janeiro
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_02" name="filter_mes_02" checked={filter_mes_02} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_02">
                                        Fevereiro
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_03" name="filter_mes_03" checked={filter_mes_03} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_03">
                                        Março
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_04" name="filter_mes_04" checked={filter_mes_04} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_04">
                                        Abril
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_05" name="filter_mes_05" checked={filter_mes_05} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_05">
                                        Maio
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_06" name="filter_mes_06" checked={filter_mes_06} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_06">
                                        Junho
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_07" name="filter_mes_07" checked={filter_mes_07} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_07">
                                        Julho
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_08" name="filter_mes_08" checked={filter_mes_08} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_08">
                                        Agosto
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_09" name="filter_mes_09" checked={filter_mes_09} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_09">
                                        Setembro
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_10" name="filter_mes_10" checked={filter_mes_10} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_10">
                                        Outubro
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_11" name="filter_mes_11" checked={filter_mes_11} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_11">
                                        Novembro
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_12" name="filter_mes_12" checked={filter_mes_12} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_12">
                                        Dezembro
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card m-1">
                        <h6 className="card-header">Posto</h6>
                        <div className="card-body d-flex flex-column justify-content-center align-items-center">
                            <div className="input-group">
                                <label className={`input-group-text`} htmlFor="inputGroupSelectPosto">Nome do posto</label>
                                <select className="form-select" id="inputGroupSelectPosto" name='posto' value={posto} onChange={element => handleSearchInputChanges(element)}>
                                    <option value="Todos">Todos</option>
                                    {postosList.map((posto: iPosto) => <option key={posto.posto_id} value={posto.posto_nome}>{posto.posto_nome}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="card m-1">
                        <h6 className="card-header">Valores</h6>
                        <div className="card-body">
                            <div className="d-flex p-2">
                                <input type="checkbox" id="filter_registrosVazios" name="filter_registrosVazios" checked={filter_registrosVazios} onChange={e => handleSearchInputChanges(e, true)} />
                                <label className="form-check-label ps-2" htmlFor="filter_registrosVazios">
                                    Registros vazios
                                </label>
                            </div>
                            <div className="d-flex p-2">
                                <input type="checkbox" id="filter_registrosIncompletos" name="filter_registrosIncompletos" checked={filter_registrosIncompletos} onChange={e => handleSearchInputChanges(e, true)} />
                                <label className="form-check-label ps-2" htmlFor="filter_registrosIncompletos">
                                    Registros incompletos
                                </label>
                            </div>
                            <div className="d-flex p-2">
                                <input type="checkbox" id="filter_totalZero" name="filter_totalZero" checked={filter_totalZero} onChange={e => handleSearchInputChanges(e, true)} />
                                <label className="form-check-label ps-2" htmlFor="filter_totalZero">
                                    Sem chuva
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="card m-1">
                        <h6 className="card-header">Soma das chuvas</h6>
                        <div className="card-body d-flex flex-column">
                            <div className="input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">Mínimo</span>
                                <input type="number" className="form-control" onKeyPress={(e) => {
                                    if (!/[0-9.,]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                    pattern="[0-9]+([,\.][0-9]+)?"
                                    inputMode="numeric" placeholder="0.0" name="filter_soma_minima" value={filter_soma_minima} onChange={e => handleSearchInputChanges(e)} />
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">Máximo</span>
                                <input type="number" className="form-control" onKeyPress={(e) => {
                                    if (!/[0-9.,]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                    pattern="[0-9]+([,\.][0-9]+)?"
                                    inputMode="numeric" placeholder="0.0" name="filter_soma_maxima" value={filter_soma_maxima} onChange={e => handleSearchInputChanges(e)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body d-flex flex-column celular-view">
                    <div className="card m-1">
                        <h6 className="card-header">Data</h6>
                        <div className="card-body d-flex flex-column">
                            <div className="input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">De</span>
                                <input type="date" className="form-control" name="filter_data_de" value={filter_data_de} onChange={e => handleSearchInputChanges(e)} />
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">até</span>
                                <input type="date" className="form-control" name="filter_data_ate" value={filter_data_ate} onChange={e => handleSearchInputChanges(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="card m-1">
                        <h6 className="card-header">Meses</h6>
                        <div className="card-body d-flex overflow-scroll">
                            <div className="d-flex flex-column">
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_01" name="filter_mes_01" checked={filter_mes_01} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_01">
                                        Janeiro
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_02" name="filter_mes_02" checked={filter_mes_02} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_02">
                                        Fevereiro
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_03" name="filter_mes_03" checked={filter_mes_03} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_03">
                                        Março
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_04" name="filter_mes_04" checked={filter_mes_04} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_04">
                                        Abril
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_05" name="filter_mes_05" checked={filter_mes_05} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_05">
                                        Maio
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_06" name="filter_mes_06" checked={filter_mes_06} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_06">
                                        Junho
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_07" name="filter_mes_07" checked={filter_mes_07} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_07">
                                        Julho
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_08" name="filter_mes_08" checked={filter_mes_08} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_08">
                                        Agosto
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_09" name="filter_mes_09" checked={filter_mes_09} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_09">
                                        Setembro
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_10" name="filter_mes_10" checked={filter_mes_10} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_10">
                                        Outubro
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_11" name="filter_mes_11" checked={filter_mes_11} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_11">
                                        Novembro
                                    </label>
                                </div>
                                <div className="d-flex p-2">
                                    <input type="checkbox" id="filter_mes_12" name="filter_mes_12" checked={filter_mes_12} onChange={e => handleSearchInputChanges(e, true)} />
                                    <label className="form-check-label ps-2" htmlFor="filter_mes_12">
                                        Dezembro
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card m-1">
                        <h6 className="card-header">Posto</h6>
                        <div className="card-body d-flex flex-column justify-content-center align-items-center">
                            <div className="input-group">
                                <label className={`input-group-text`} htmlFor="inputGroupSelectPosto">Nome do posto</label>
                                <select className="form-select" id="inputGroupSelectPosto" name='posto' value={posto} onChange={element => handleSearchInputChanges(element)}>
                                    <option value="Todos">Todos</option>
                                    {postosList.map((posto: iPosto) => <option key={posto.posto_id} value={posto.posto_nome}>{posto.posto_nome}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="card m-1">
                        <h6 className="card-header">Valores</h6>
                        <div className="card-body">
                            <div className="d-flex p-2">
                                <input type="checkbox" id="filter_registrosVazios" name="filter_registrosVazios" checked={filter_registrosVazios} onChange={e => handleSearchInputChanges(e, true)} />
                                <label className="form-check-label ps-2" htmlFor="filter_registrosVazios">
                                    Registros vazios
                                </label>
                            </div>
                            <div className="d-flex p-2">
                                <input type="checkbox" id="filter_registrosIncompletos" name="filter_registrosIncompletos" checked={filter_registrosIncompletos} onChange={e => handleSearchInputChanges(e, true)} />
                                <label className="form-check-label ps-2" htmlFor="filter_registrosIncompletos">
                                    Registros incompletos
                                </label>
                            </div>
                            <div className="d-flex p-2">
                                <input type="checkbox" id="filter_totalZero" name="filter_totalZero" checked={filter_totalZero} onChange={e => handleSearchInputChanges(e, true)} />
                                <label className="form-check-label ps-2" htmlFor="filter_totalZero">
                                    Sem chuva
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="card m-1">
                        <h6 className="card-header">Soma das chuvas</h6>
                        <div className="card-body d-flex flex-column">
                            <div className="input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">Mínimo</span>
                                <input type="number" className="form-control" onKeyPress={(e) => {
                                    if (!/[0-9.,]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                    pattern="[0-9]+([,\.][0-9]+)?"
                                    inputMode="numeric" placeholder="0.0" name="filter_soma_minima" value={filter_soma_minima} onChange={e => handleSearchInputChanges(e)} />
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">Máximo</span>
                                <input type="number" className="form-control" onKeyPress={(e) => {
                                    if (!/[0-9.,]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                    pattern="[0-9]+([,\.][0-9]+)?"
                                    inputMode="numeric" placeholder="0.0" name="filter_soma_maxima" value={filter_soma_maxima} onChange={e => handleSearchInputChanges(e)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex m-2 justify-content-center">
                    <button className="btn btn-warning m-2 w-25" onClick={handleClear}>Limpar</button>
                    <button className="btn btn-primary m-2 w-25" onClick={handleBuscar}>Buscar</button>
                </div>
            </div>
            <div className='d-flex justify-content-center'>
                {isLoading ?
                    <div className="spinner-border text-primary" style={{ height: '100px', width: '100px' }} role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    :
                    <div className="card m-5 css-app-cinza-claro">
                        <h5 className="card-header">Registros</h5>
                        <div className="d-flex justify-content-between me-3 ms-3 align align-items-center mt-3">
                            <div className="d-flex flex-column">
                                <h6>Filtrados: {filteredList.length}</h6>
                                <h6>Total: {registros.length}</h6>
                            </div>
                            <button className="btn btn-secondary align-self-end" onClick={handlePdf}>
                                <i className="bi bi-filetype-xlsx pe-2"></i>
                                Exportar
                            </button>
                        </div>
                        <div className="card-body d-flex table-responsive">
                            <table className="table table-bordered table-striped table-hover w-100">
                                <thead>
                                    <tr>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">#</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Posto</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Ano</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Mês</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Latitude</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Logitude</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Altitude</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dias com chuva</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dias sem registro</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dias com chuva zero</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Soma das chuvas</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 01</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 02</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 03</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 04</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 05</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 06</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 07</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 08</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 09</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 10</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 11</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 12</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 13</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 14</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 15</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 16</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 17</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 18</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 19</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 10</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 21</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 22</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 23</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 24</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 25</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 26</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 27</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 28</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 29</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 30</th>
                                        <th className='ps-2 pe-2 text-nowrap' scope="col">Dia 31</th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {
                                        filteredList.map((registro: iRegistros, index: number) =>
                                            <tr key={uuid()} className="text">
                                                <th scope="row" className="align-middle">{index + 1}</th>
                                                <td className="align-middle text-nowrap">{registro.posto_nome}</td>
                                                <td className="align-middle"> {registro.ano}</td>
                                                <td className="align-middle"> {numeroToMes(registro.mes)}</td>
                                                <td className="align-middle">{registro.posto_lat}</td>
                                                <td className="align-middle">{registro.posto_lon}</td>
                                                <td className="align-middle">{registro.posto_alt}</td>
                                                <td className="align-middle">{diasComChuva(registro)}</td>
                                                <td className="align-middle">{diasSemRegistro(registro)}</td>
                                                <td className="align-middle">{contarDiasZero(registro)}</td>
                                                <td className="align-middle">{somarDias(registro)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_01)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_02)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_03)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_04)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_05)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_06)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_07)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_08)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_09)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_10)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_11)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_12)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_13)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_14)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_15)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_16)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_17)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_18)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_19)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_20)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_21)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_22)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_23)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_24)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_25)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_26)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_27)}</td>
                                                <td className="align-middle"> {chuvaFormatada(registro.dia_28)}</td>
                                                {numeroDeDiasDoMes(registro.mes, registro.ano) >= 29 && <td className="align-middle"> {chuvaFormatada(registro.dia_29)}</td>}
                                                {numeroDeDiasDoMes(registro.mes, registro.ano) >= 30 && <td className="align-middle"> {chuvaFormatada(registro.dia_30)}</td>}
                                                {numeroDeDiasDoMes(registro.mes, registro.ano) === 31 && <td className="align-middle"> {chuvaFormatada(registro.dia_31)}</td>}
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>
                        <button className="btn btn-secondary m-3 align-self-end" onClick={handlePdf}>
                            <i className="bi bi-filetype-xlsx pe-2"></i>
                            Exportar
                        </button>
                    </div>
                }
            </div>
        </>
    );
};

export default ConsultarRegistro;